export default __webpack_public_path__ + "static/media/support.f3a26b0f.svg";